function MenuBar(){
    return (
        <div></div>
    );
};

export default MenuBar;